import {urlGenerator} from "../../../application/helpers/AxiosHelper";
import {POST_FEED, POSTS} from "../../../application/config/ApiUrl";
import axios from 'axios';

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        page: 1,
        per_page: 10,
        list: [],
        no_more: false
    }),
    mutations: {
        SET_LOADING: (state, payloads) => state.loading = payloads,
        SET_LIST: (state, payloads) => state.list = payloads,
        SET_RECENT: (state, payloads) => state.list.unshift({...payloads, recent: true}),
        SET_NO_MORE: (state, payloads) => state.no_more = payloads
    },
    actions: {
        getAll: (context, {loader = true, id, teamId}) => {
            if (!context.state.no_more) {
                context.commit('SET_LOADING', loader)

                let params = {
                    page: context.state.page,
                    per_page: context.state.per_page
                }
                if(teamId) params.team = teamId
                return axios.get(urlGenerator(POST_FEED) + `${id ? '/' + id : ''}`, {
                    params
                })
                    .then(res => {
                        context.commit('SET_LIST', [...context.state.list, ...res.data.data])
                        context.commit('SET_NO_MORE', context.state.page === res.data.last_page)
                        context.state.page += 1
                    })
                    .finally(() => context.commit('SET_LOADING', false))
            }
        },
        create: (context, payloads) => {
            context.commit('SET_LOADING', true)
            return axios.post(urlGenerator(POSTS), payloads).then(res => {
                context.commit('SET_RECENT', res.data.post)
                return res
            }).finally(() => {
                context.commit('SET_LOADING', false)
            })
        },
        update: (context, {formData, id}) => {
            return axios.post(urlGenerator(POSTS + '/' + id), formData)
                .then(res => {
                    Object.assign(context.state.list.find(post => post.id === id), { ...res.data.post, recent: true })
                    return res
                })
                .catch(err => {})
                .finally(() => {})
        },
        delPost: (context, id) => {
            return axios.delete(urlGenerator(POSTS + '/' + id)).then(res => {
                context.commit('SET_LIST', context.state.list.filter(item => item.id !== id))
                return res
            }).finally(() => {
            })
        },
    },
    getters: {
        loading: state => state.loading,
        list: state => state.list,
        post: state => id => state.list.find(item => item.id === id),
        recent: state => state.recent,
    }
}
